"use client";

import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClientProvider } from "@tanstack/react-query";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";
import { ScriptOnce } from "@tanstack/react-router";
import { useEffect } from "react";
import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { UserContextTracker } from "@/components/user-context-tracker";
import { ThemeProvider, themeScript } from "@/components/theme-provider";
import { useQueryClient } from "@tanstack/react-query";
import { ProgressProvider } from "@bprogress/react";
import { FeatureFlagsProvider } from "@/lib/features/FeatureFlagsProvider";

export function Providers({ children }: { children: React.ReactNode }) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (import.meta.env.VITE_POSTHOG_KEY) {
      posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
        api_host: "https://e.scoopulator.app/",
        ui_host: "https://us.posthog.com",
        defaults: "2025-05-24",
        capture_exceptions: false,
        debug: import.meta.env.DEV,
        cookieless_mode: "always",
        autocapture: false,
        capture_performance: false,
        advanced_disable_feature_flags: true,
        opt_out_capturing_by_default: import.meta.env.DEV,
      });
    }
  }, []);

  return (
    <ThemeProvider>
      <ScriptOnce>{themeScript}</ScriptOnce>
      <PHProvider client={posthog}>
        <TooltipProvider>
          <NuqsAdapter>
            <ProgressProvider
              color="hsl(var(--primary))"
              options={{ showSpinner: false }}
            >
              <QueryClientProvider client={queryClient}>
                <FeatureFlagsProvider>
                  <UserContextTracker />
                  {children}
                </FeatureFlagsProvider>
              </QueryClientProvider>
            </ProgressProvider>
          </NuqsAdapter>
        </TooltipProvider>
      </PHProvider>
    </ThemeProvider>
  );
}
